import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import AxiosConfig from "../services/AxiosConfig";
import "./ContactSelect.scss";

/**
 * Select a saved Settings contact and apply address / contact fields.
 * preferredLabel: "Loading point" | "Delivery point"
 */
const ContactSelect = ({
  preferredLabel = "Loading point",
  onSelect,
  label = "Select saved contact",
  className = "",
}) => {
  const [contacts, setContacts] = useState([]);
  const [selectedId, setSelectedId] = useState("");

  const userDetail = JSON.parse(localStorage.getItem("userDetail") || "{}");
  const ownerId = userDetail._id || "";

  useEffect(() => {
    const load = async () => {
      if (!ownerId) return;
      try {
        const response = await AxiosConfig.instance.get("/get_contacts", {
          params: { ownerId },
        });
        if (response.data.success) {
          setContacts(response.data.data || []);
        }
      } catch (err) {
        console.error("Error loading contacts for quotes", err);
      }
    };
    load();
  }, [ownerId]);

  const pickByLabel = (items = []) => {
    if (!items.length) return null;
    return items.find((item) => item.label === preferredLabel) || null;
  };

  const handleChange = (e) => {
    const id = e.target.value;
    setSelectedId(id);
    if (!id) {
      onSelect?.(null);
      return;
    }

    const contact = contacts.find((c) => c._id === id);
    if (!contact) return;

    const addressEntry = pickByLabel(contact.addresses || []);
    const persons = contact.contactPersons || [];
    const person =
      pickByLabel(persons) ||
      persons[0] ||
      null;
    const phoneCode = person?.phoneCode || "";
    const phone = person?.phone || "";
    const fullPhone =
      phoneCode && phone && !String(phone).startsWith("+")
        ? `${phoneCode}${phone}`
        : phone;

    onSelect?.({
      companyName: contact.companyName || "",
      address: addressEntry?.address || "",
      contactName: person?.fullName || "",
      contactPhone: fullPhone || phone,
      contactEmail: person?.email || "",
    });
  };

  // Loading dropdown → only contacts with Loading point
  // Delivery dropdown → only contacts with Delivery point
  // Contact with both addresses appears in both dropdowns
  const visibleContacts = contacts.filter((contact) =>
    (contact.addresses || []).some((a) => a.label === preferredLabel)
  );

  if (!visibleContacts.length) {
    return null;
  }

  return (
    <Form.Group className={`contact-select-group mb-3 ${className}`}>
      <Form.Label>{label}</Form.Label>
      <Form.Select
        value={selectedId}
        onChange={handleChange}
        className="contact-select-dropdown"
      >
        <option value="">— Choose a contact —</option>
        {visibleContacts.map((contact) => (
          <option key={contact._id} value={contact._id}>
            {contact.companyName}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};

export default ContactSelect;
